import React from 'react';
import { Home, Star, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const AccommodationDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Accommodation</h1>
              <p className="text-gray-600 mt-1">Find your perfect student housing</p>
            </div>
            <Link to="/services" className="px-4 py-2 text-sm text-teal-600 hover:text-teal-700 font-medium transition-colors">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200">
            <div className="bg-teal-100 p-3 rounded-lg w-fit mb-4 group-hover:bg-teal-600 transition-colors">
              <Home className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-teal-600 transition-colors">Search Housing</h3>
            <p className="text-sm text-gray-600 mt-2">Find accommodation near your university</p>
          </div>
          <div className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200">
            <div className="bg-teal-100 p-3 rounded-lg w-fit mb-4 group-hover:bg-teal-600 transition-colors">
              <Star className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-teal-600 transition-colors">Saved Listings</h3>
            <p className="text-sm text-gray-600 mt-2">Track your favorite properties</p>
          </div>
          <div className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200">
            <div className="bg-teal-100 p-3 rounded-lg w-fit mb-4 group-hover:bg-teal-600 transition-colors">
              <Phone className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-teal-600 transition-colors">Contact Landlords</h3>
            <p className="text-sm text-gray-600 mt-2">Message property owners directly</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Available Accommodations</h2>
          <p className="text-gray-600">Housing search and booking platform coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default AccommodationDashboard;
